var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    [
      _c(
        "router-link",
        {
          staticClass: "custom-a-blue",
          attrs: {
            to: _vm.linkPath,
            target: _vm.shouldOpenInNewTab ? "_blank" : "_self",
          },
        },
        [_vm._v("\n        " + _vm._s(_vm.linkText) + "\n    ")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }